import { api } from './client';

/**
 * Models API client for the writer's computed model menu.
 */
export const modelsApi = {
  /**
   * Get the writer's computed model menu for pulldown rendering.
   * Returns the checked menu grouped into "default" (curated set, each with
   * a verbatim note) and "added" (writer's own catalog picks, note is null).
   * @returns {Promise<ModelsResponse>} { models: { default: Model[], added: Model[] } }
   */
  getAvailable: () => api.get('/models')
};

/**
 * @typedef {Object} Model
 * @property {string} id - OpenRouter model ID (e.g., 'anthropic/claude-sonnet-5')
 * @property {string} display_name - Human-readable model name
 * @property {string|null} note - Curated 1-2 sentence blurb (default entries only; null for added entries)
 */

/**
 * @typedef {Object} ModelsResponse
 * @property {Object} models - Computed menu
 * @property {Model[]} models.default - Curated default models (with notes)
 * @property {Model[]} models.added - Writer's own catalog additions (note is always null)
 */
